// Vertical card holding a single facet group. Generic enough for the three
// variants we need in this batch: pill toggle, tri-state, checkbox list.
import type { ReactNode } from "react";

interface FacetCardProps {
  title: string;
  selectedCount?: number;
  defaultOpen?: boolean;
  children: ReactNode;
}

export function FacetCard({ title, selectedCount, defaultOpen = false, children }: FacetCardProps) {
  return (
    <details className="facet-card" open={defaultOpen}>
      <summary className="facet-card__header">
        <span className="facet-card__name">
          {title}
          {selectedCount && selectedCount > 0 ? (
            <span className="facet-card__count">{selectedCount}</span>
          ) : null}
        </span>
        <span className="facet-card__chevron" aria-hidden="true">›</span>
      </summary>
      <div className="facet-card__body">{children}</div>
    </details>
  );
}
